import React, {  useState, useEffect } from 'react'
import {  RETURN_REFUND_POLICY_URL } from '../../constants/api'
import axios from 'axios';

const ReturnRefundPolicyComponent = (props) => {
    const [data, setData] = useState([]);
    

    // alert(JSON.stringify(data))

    useEffect(() => {
        fetchPrivacyPolicy(RETURN_REFUND_POLICY_URL)
    }, [])

    const fetchPrivacyPolicy = async (url) => {
        const result = await axios(
            url,
        );
        setData(data => [...data, ...result.data.results]);
        
    };


    return (
        <div>
            <main className="main">
            <div className="page-content mt-10 pt-7">
                <section className="about-section">
                    <div className="container">
                        <h1 className="title mb-lg-12 font-weight-bold" style={{fontSize: "25px"}}>Return & Refund Policy</h1>
                        <div className="row mb-10">
                            <div className="col-md-12">
                            
                               
                                {data.map(returnrefund=>(
                                    
                                <p>{Object.keys(returnrefund).length>0 ? <div dangerouslySetInnerHTML={{__html: returnrefund.return_refund_policy}} /> : ''}</p>
                                ))}  
                                
                           
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- End About Section--> */}
            </div>
</main>
        </div>
    )
}

export default ReturnRefundPolicyComponent
